// ---------------------------------------------------------------------------
// แพ็คเสริม (Add-ons) — ซื้อเพิ่มจากแพ็กเกจหลัก
// ---------------------------------------------------------------------------
// มี 2 กลุ่ม
//   1. ปั้มโซเชียล  = เติมเงินได้ "point" (ไม่มีวันหมดอายุ ไม่คืนเป็นเงิน) ใช้สั่งปั้มไลค์/ฟอลโลว์เท่านั้น
//      - แพ็คปั้มไลค์ / แพ็คปั้มฟอลโลว์ / เติม point ทั่วไป ได้ point กองเดียวกัน
//      - สั่งปั้มแล้วระบบบันทึกออเดอร์ "รอดำเนินการ" ทีมงานทำให้เองแล้วเปลี่ยนสถานะในชีต
//   2. แพ็คเสริมของแพ็กเกจ = จ่ายเงินสด (QR) ผูกกับอายุแพ็กเกจหลัก
//      - ฟีเจอร์เสริม: ซื้อโมดูลที่แพ็กเกจปัจจุบันไม่มี
//      - อัปเกรดแพ็คเสริม: เพิ่มโควตา สาขา / พนักงาน / ลูกค้า / ที่เก็บไฟล์
//      คิดเงินตามวันที่เหลือของแพ็กเกจหลัก (ราคา/เดือน × วันที่เหลือ / 30) และหมดอายุพร้อมแพ็กเกจหลัก
//
// ราคาเป็นบาท ยังไม่รวม VAT — แก้ราคา/อัตราได้ที่ไฟล์นี้ที่เดียว
// ---------------------------------------------------------------------------

// ----------------------------- ปั้มโซเชียล -----------------------------

export const BOOST_TYPES = [
  { key: "like", name: "ปั้มไลค์", nameEn: "Likes", unit: "ไลค์", unitEn: "likes", icon: "heart" },
  { key: "follow", name: "ปั้มฟอลโลว์", nameEn: "Followers", unit: "คน", unitEn: "followers", icon: "userPlus" },
];

export const BOOST_PLATFORMS = [
  { key: "facebook", name: "Facebook", hosts: ["facebook.com", "fb.com", "fb.watch"] },
  { key: "instagram", name: "Instagram", hosts: ["instagram.com"] },
  { key: "tiktok", name: "TikTok", hosts: ["tiktok.com"] },
  { key: "youtube", name: "YouTube", hosts: ["youtube.com", "youtu.be"] },
];

export const BOOST_PLATFORM_MAP = BOOST_PLATFORMS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

/**
 * บริการปั้ม = แพลตฟอร์ม × ประเภท
 * rate = point ต่อ 1 หน่วย (ไลค์/คน) — ฟอลโลว์แพงกว่าไลค์เพราะคงอยู่ถาวรและหลุดง่ายกว่า
 * targetHint = ต้องใส่ลิงก์อะไร (ไลค์ = ลิงก์โพสต์, ฟอลโลว์ = ลิงก์เพจ/โปรไฟล์)
 */
export const BOOST_SERVICES = [
  { key: "facebook_like", platform: "facebook", type: "like", rate: 0.3, eta: "1-3 วัน", etaEn: "1-3 days" },
  { key: "facebook_follow", platform: "facebook", type: "follow", rate: 0.6, eta: "2-5 วัน", etaEn: "2-5 days" },
  { key: "instagram_like", platform: "instagram", type: "like", rate: 0.25, eta: "1-2 วัน", etaEn: "1-2 days" },
  { key: "instagram_follow", platform: "instagram", type: "follow", rate: 0.5, eta: "2-5 วัน", etaEn: "2-5 days" },
  { key: "tiktok_like", platform: "tiktok", type: "like", rate: 0.2, eta: "1-2 วัน", etaEn: "1-2 days" },
  { key: "tiktok_follow", platform: "tiktok", type: "follow", rate: 0.5, eta: "2-5 วัน", etaEn: "2-5 days" },
  { key: "youtube_like", platform: "youtube", type: "like", rate: 0.5, eta: "2-4 วัน", etaEn: "2-4 days" },
  { key: "youtube_follow", platform: "youtube", type: "follow", rate: 1.5, eta: "3-7 วัน", etaEn: "3-7 days" },
];

export const BOOST_SERVICE_MAP = BOOST_SERVICES.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

export const boostServiceOf = (platform, type) =>
  BOOST_SERVICES.find((item) => item.platform === platform && item.type === type) || null;

/** จำนวนต่อออเดอร์ — สั่งเป็นหลักร้อย */
export const BOOST_QTY = { min: 100, max: 50000, step: 100 };

/** ปัดเศษ point ขึ้นเสมอ (ไม่ให้ร้านได้ของฟรีจากทศนิยม) */
export const boostCost = (serviceKey, quantity) => {
  const service = BOOST_SERVICE_MAP[serviceKey];
  const qty = Number(quantity) || 0;
  if (!service || qty <= 0) return 0;
  return Math.ceil(service.rate * qty);
};

/** สถานะออเดอร์ปั้ม — ทีมงานเปลี่ยนในชีต boost_orders */
export const BOOST_STATUS = {
  pending: { th: "รอดำเนินการ", en: "Pending", tone: "amber" },
  in_progress: { th: "กำลังปั้ม", en: "In progress", tone: "sky" },
  completed: { th: "เสร็จสิ้น", en: "Completed", tone: "green" },
  cancelled: { th: "ยกเลิก (คืน point แล้ว)", en: "Cancelled (refunded)", tone: "red" },
};

/** ลิงก์ต้องเป็น http(s) และอยู่บนโดเมนของแพลตฟอร์มที่เลือก */
export const validBoostUrl = (platform, url) => {
  const target = BOOST_PLATFORM_MAP[platform];
  if (!target) return false;
  try {
    const parsed = new URL(String(url || "").trim());
    if (!["http:", "https:"].includes(parsed.protocol)) return false;
    const host = parsed.hostname.toLowerCase();
    return target.hosts.some((item) => host === item || host.endsWith(`.${item}`));
  } catch (e) {
    return false;
  }
};

// ----------------------------- แพ็ค point -----------------------------
// อัตราพื้นฐาน 1 บาท = 1 point · ยิ่งเติมเยอะยิ่งได้โบนัส
// แพ็คไลค์/ฟอลโลว์ ให้โบนัสมากกว่าเติมทั่วไปเล็กน้อย (โปรโมชั่นให้ซื้อเป็นแพ็ค)
// approx = ประมาณว่าได้กี่ไลค์/คน (คิดจาก Facebook) ไว้โชว์ให้เห็นภาพ

export const POINT_RATE = 1; // point ต่อ 1 บาท

export const POINT_PACKS = [
  // --- แพ็คปั้มไลค์ ---
  { key: "like_s", group: "like", name: "แพ็คไลค์ S", nameEn: "Like pack S", price: 300, points: 315 },
  { key: "like_m", group: "like", name: "แพ็คไลค์ M", nameEn: "Like pack M", price: 1000, points: 1100, featured: true },
  { key: "like_l", group: "like", name: "แพ็คไลค์ L", nameEn: "Like pack L", price: 3000, points: 3450 },
  // --- แพ็คปั้มฟอลโลว์ ---
  { key: "follow_s", group: "follow", name: "แพ็คฟอลโลว์ S", nameEn: "Follower pack S", price: 500, points: 525 },
  { key: "follow_m", group: "follow", name: "แพ็คฟอลโลว์ M", nameEn: "Follower pack M", price: 1500, points: 1650, featured: true },
  { key: "follow_l", group: "follow", name: "แพ็คฟอลโลว์ L", nameEn: "Follower pack L", price: 5000, points: 5750 },
  // --- เติม point ทั่วไป ---
  { key: "topup_100", group: "topup", name: "เติม 100 point", nameEn: "100 points", price: 100, points: 100 },
  { key: "topup_500", group: "topup", name: "เติม 500 point", nameEn: "500 points", price: 500, points: 500 },
  { key: "topup_1000", group: "topup", name: "เติม 1,000 point", nameEn: "1,000 points", price: 1000, points: 1050 },
  { key: "topup_5000", group: "topup", name: "เติม 5,000 point", nameEn: "5,000 points", price: 5000, points: 5400 },
  { key: "topup_10000", group: "topup", name: "เติม 10,000 point", nameEn: "10,000 points", price: 10000, points: 11000 },
  // --- เครดิต AI (wallet แยกจาก point ปั้ม) ใช้กับงาน AI ที่กินพลังประมวลผลสูง เช่น ถอดเสียง/โมเดลทำนาย ---
  { key: "ai_s", group: "ai", wallet: "ai", name: "เครดิต AI S", nameEn: "AI credits S", price: 1000, points: 1050 },
  { key: "ai_m", group: "ai", wallet: "ai", name: "เครดิต AI M", nameEn: "AI credits M", price: 5000, points: 5750, featured: true },
  { key: "ai_l", group: "ai", wallet: "ai", name: "เครดิต AI L", nameEn: "AI credits L", price: 20000, points: 24000 },
];

export const POINT_PACK_MAP = POINT_PACKS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

/** เติมจำนวนเอง — ขั้นต่ำ/สูงสุด และโบนัสตามยอด (ใช้ขั้นสูงสุดที่ถึง) */
export const CUSTOM_TOPUP = { min: 100, max: 100000 };
export const TOPUP_BONUS = [
  { from: 10000, percent: 10 },
  { from: 5000, percent: 8 },
  { from: 1000, percent: 5 },
];

export const pointsForAmount = (amount) => {
  const value = Math.floor(Number(amount) || 0);
  if (value < CUSTOM_TOPUP.min || value > CUSTOM_TOPUP.max) return 0;
  const tier = TOPUP_BONUS.find((row) => value >= row.from);
  const base = value * POINT_RATE;
  return base + Math.floor((base * (tier?.percent || 0)) / 100);
};

/** ได้ประมาณกี่หน่วย ถ้าใช้ point ทั้งหมดกับบริการนี้ (ปัดลงเป็นหลักร้อย) */
export const approxUnits = (points, serviceKey) => {
  const service = BOOST_SERVICE_MAP[serviceKey];
  if (!service) return 0;
  return Math.floor(points / service.rate / BOOST_QTY.step) * BOOST_QTY.step;
};

// ------------------------- แพ็คเสริมของแพ็กเกจ -------------------------

/** ฟีเจอร์เสริม: ราคา/เดือน ของโมดูลที่ซื้อแยกได้ (โมดูลหลัก crm/catalog/billing มีทุกแพ็กเกจอยู่แล้ว) */
export const MODULE_ADDON_PRICES = {
  booking: 5000,
  slip: 5000,
  chat: 8000,
  resource: 8000,
  membership: 10000,
  campaign: 15000,
  pos: 12000,
  oms: 12000,
  inventory: 10000,
  course: 8000,
  fleet: 15000,
  installment: 20000,
  contract: 15000,
  field_service: 15000,
  etax: 2500,
  online_payment: 3000,
  data_export: 3500,
  white_label: 5000,
  // AI ชุด Enterprise (กำลังเปิดให้ใช้งาน) — ร้าน Starter ซื้อเสริมได้
  ai_churn: 12000,
  ai_sentiment: 9000,
  ai_sales_agent: 15000,
  ai_whatif: 12000,
};

/**
 * ฟีเจอร์เสริมแบบขอใบเสนอราคา: ยังไม่มีราคากลาง ทีมงานประเมินราคาให้แต่ละร้าน
 * กด "ขอใบเสนอราคา" = สร้างคำขอ custom (หัวข้อ "ฟีเจอร์เสริม: <ชื่อ>") แล้วไปตาม flow ใบเสนอราคาเดิม
 * ("สต็อกสินค้า" มีอยู่แล้วในโมดูล inventory จึงไม่อยู่ในรายการนี้)
 */
export const QUOTE_FEATURES = [
  { key: "mobile_app", name: "Mobile App", nameEn: "Mobile App", icon: "mobile", detail: "แอปมือถือของร้าน" },
  { key: "material", name: "จัดการวัตถุดิบ (Material)", nameEn: "Material management", icon: "boxes", detail: "วัตถุดิบ สูตรการผลิต ตัดวัตถุดิบ" },
  { key: "advanced_report", name: "รายงานขั้นสูง", nameEn: "Advanced reports", icon: "chartBar", detail: "รายงานเชิงลึก เปรียบเทียบช่วงเวลา" },
  { key: "report_builder", name: "ออกแบบรายงานเอง", nameEn: "Report builder", icon: "chartPie", detail: "เลือกคอลัมน์ ตัวกรอง จัดรูปแบบรายงานเอง" },
  { key: "executive_dashboard", name: "แดชบอร์ดผู้บริหาร", nameEn: "Executive dashboard", icon: "dashboard", detail: "ภาพรวมยอดขายและ KPI ทุกสาขา" },
  { key: "purchasing", name: "จัดซื้อ & Supplier", nameEn: "Purchasing & suppliers", icon: "truck", detail: "ใบขอซื้อ ใบสั่งซื้อ ทะเบียน supplier" },
  { key: "multi_warehouse", name: "คลังสินค้าหลายสาขา", nameEn: "Multi-branch warehouse", icon: "building", detail: "แยกสต็อกตามสาขา โอนย้ายระหว่างคลัง" },
  { key: "stock_count", name: "ตรวจนับสต็อก", nameEn: "Stock count", icon: "checkSquare", detail: "นับสต็อกจริง เทียบยอดในระบบ ปรับยอด" },
  { key: "sales_pipeline", name: "Sales Pipeline", nameEn: "Sales pipeline", icon: "target", detail: "ติดตามดีลตามขั้นการขาย" },
  { key: "helpdesk", name: "Helpdesk & Ticket", nameEn: "Helpdesk & tickets", icon: "ticket", detail: "รับเรื่อง แจ้งปัญหา ติดตามสถานะ" },
  { key: "task_team", name: "จัดการงาน & ทีม", nameEn: "Tasks & teams", icon: "staff", detail: "มอบหมายงาน กำหนดส่ง ติดตามความคืบหน้า" },
  { key: "time_attendance", name: "ลงเวลาพนักงาน", nameEn: "Time attendance", icon: "clock", detail: "เข้า-ออกงาน สรุปชั่วโมงทำงาน" },
  { key: "satisfaction_survey", name: "แบบสอบถามความพึงพอใจ", nameEn: "Satisfaction survey", icon: "star", detail: "ส่งแบบสอบถาม สรุปคะแนนความพึงพอใจ" },
  { key: "line_mini_app", name: "LINE Mini App", nameEn: "LINE Mini App", icon: "chat", detail: "หน้าร้าน/สมาชิกบน LINE" },
];

export const quoteFeatureTitle = (item) => `ฟีเจอร์เสริม: ${item.name}`;

/**
 * บริการติดตั้ง & อบรม (จ่ายครั้งเดียว ราคาคงที่) — ซื้อแล้วสร้างคำขอ custom ที่มีใบเสนอราคาแล้ว (quoted)
 * แล้วจ่ายผ่าน flow ใบเสนอราคาเดิม ทีมงานเห็นในชีต custom_requests · ราคา = mandays × rate (rate ต้อง >= CUSTOM_MIN_RATE)
 */
export const SERVICE_PACKAGES = [
  { key: "setup", name: "ตั้งค่าระบบเริ่มต้น (Implementation)", nameEn: "Implementation setup", icon: "settings", mandays: 2, rate: 5000, detail: "ตั้งค่าร้าน สาขา พนักงาน สิทธิ์ และเชื่อมช่องทางแชท" },
  { key: "migration", name: "ย้ายข้อมูลเดิม (Data Migration)", nameEn: "Data migration", icon: "upload", mandays: 3, rate: 5000, detail: "นำเข้าข้อมูลลูกค้า สินค้า และประวัติการขายจากระบบเดิม" },
  { key: "training", name: "อบรมทีมงาน 1 ครั้ง (Training)", nameEn: "Team training (1 session)", icon: "graduation", mandays: 1, rate: 6000, detail: "อบรมออนไลน์/ที่ร้าน ไม่เกิน 3 ชม. ต่อครั้ง" },
  { key: "ai_onboarding", name: "ตั้งค่า AI & ปรับ Workflow", nameEn: "AI onboarding & workflow tuning", icon: "bolt", mandays: 3, rate: 6000, detail: "ตั้งค่า AI Follow-up, Lead Routing และ Trigger ให้ตรงกับธุรกิจ" },
];

export const SERVICE_MAP = SERVICE_PACKAGES.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

export const serviceTitle = (item) => `บริการ: ${item.name}`;

/** อัปเกรดแพ็คเสริม: เพิ่มโควตาเป็นก้อน ราคา/ก้อน/เดือน (ใช้ได้เฉพาะแพ็กเกจที่โควตาไม่ไม่จำกัด) */
export const QUOTA_ADDONS = [
  { key: "branches", block: 1, price: 3000, name: "สาขาเพิ่ม", nameEn: "Extra branch", unit: "สาขา", unitEn: "branch" },
  { key: "staff", block: 5, price: 2500, name: "พนักงานเพิ่ม", nameEn: "Extra staff", unit: "คน", unitEn: "staff" },
  { key: "customers", block: 5000, price: 3000, name: "ลูกค้าเพิ่ม", nameEn: "Extra customers", unit: "ราย", unitEn: "customers" },
  { key: "storage", block: 10, price: 500, name: "ที่เก็บไฟล์เพิ่ม", nameEn: "Extra storage", unit: "GB", unitEn: "GB" },
];

export const QUOTA_ADDON_MAP = QUOTA_ADDONS.reduce((acc, item) => {
  acc[item.key] = item;
  return acc;
}, {});

const DAY_MS = 86400000;

/** วันที่เหลือจากวันนี้ถึง expireAt (อย่างน้อย 0) */
export const daysUntil = (expireAt, now = new Date()) =>
  Math.max(0, Math.ceil((new Date(expireAt).getTime() - new Date(now).getTime()) / DAY_MS));

/**
 * ราคาแพ็คเสริมตามวันที่เหลือ — จาก start (ปกติ = วันนี้ หรือวันหมดอายุเดิมของแพ็คเสริมตอนต่ออายุ)
 * ถึงวันหมดอายุแพ็กเกจหลัก ขั้นต่ำคิด 1 วัน ปัดขึ้นเป็นบาท
 */
export const proratePrice = (monthlyPrice, planExpireAt, start = new Date()) => {
  const from = new Date(start) > new Date() ? new Date(start) : new Date();
  const days = Math.max(1, Math.ceil((new Date(planExpireAt).getTime() - from.getTime()) / DAY_MS));
  return { days, amount: Math.ceil((Number(monthlyPrice) * days) / 30) };
};

/** แพ็คเสริมที่ยังไม่หมดอายุ (และแพ็กเกจหลักต้องยังใช้งานอยู่ — เช็คที่ผู้เรียก) */
export const activeAddons = (organization, now = new Date()) =>
  (Array.isArray(organization?.addons) ? organization.addons : []).filter(
    (item) => item && item.expireAt && new Date(item.expireAt) > new Date(now)
  );

/** โมดูลที่ได้จากฟีเจอร์เสริม */
export const addonModules = (organization, now) =>
  Array.from(new Set(activeAddons(organization, now).filter((item) => item.kind === "module").map((item) => item.key)));

/** โควตาที่ได้เพิ่มจากแพ็คเสริม เช่น { branches: 2, staff: 10, customers: 0 } */
export const addonQuota = (organization, now) =>
  activeAddons(organization, now)
    .filter((item) => item.kind === "quota")
    .reduce(
      (acc, item) => {
        acc[item.key] = (acc[item.key] || 0) + (Number(item.amount) || 0);
        return acc;
      },
      { branches: 0, staff: 0, customers: 0, storage: 0 }
    );
